const Offer = () => null;
export default Offer;
